var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgImgProfile(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 175,
    height: 175,
    viewBox: "0 0 175 175",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_612_21499)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 175,
    height: 175,
    rx: 87.5,
    fill: "#FFF6EB"
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_612_21499)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M87.5085 165.202L122.177 156.447C141.965 140.016 154.569 115.231 154.569 87.5002C154.569 44.7264 124.59 8.95493 84.4966 0.0507812C37.5625 1.63364 0 40.1801 0 87.4999C0 111.806 9.91211 133.795 25.9123 149.651L87.5085 165.202Z",
    fill: "#CBE2FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M152.754 87.5C152.754 116.182 138.952 141.638 117.629 157.595L149.085 149.652C165.086 133.796 175 111.807 175 87.5C175 39.175 135.825 0 87.5 0C83.7321 0 80.0195 0.238574 76.377 0.700684C119.45 6.16533 152.754 42.9434 152.754 87.5Z",
    fill: "#BED8FB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M109.245 33.1381C109.245 28.6691 105.623 25.0464 101.154 25.0464H73.2693C62.9843 25.0464 54.6465 33.3842 54.6465 43.6692V64.3455H120.343V43.9625C120.343 39.4935 116.72 35.8708 112.251 35.8708H111.978C110.469 35.8708 109.245 34.6475 109.245 33.1381Z",
    fill: "#365E7D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M112.251 35.8706H111.978C110.469 35.8706 109.245 34.647 109.245 33.1376C109.245 28.6686 105.623 25.0459 101.154 25.0459H98.0962V64.345H120.342V43.962C120.343 39.4937 116.72 35.8706 112.251 35.8706Z",
    fill: "#2B4D66"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M145.279 127.27C143.14 125.157 140.493 123.523 137.489 122.572L113.601 115.008L87.5053 114.091L61.3988 115.008L37.5103 122.572C29.4289 125.13 23.9365 132.63 23.9365 141.107V147.633C39.2453 163.81 60.6629 174.146 84.4971 174.95C111.201 169.018 133.418 151.169 145.279 127.27Z",
    fill: "#4A80AA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M151.063 147.633V141.107C151.063 135.113 148.315 129.611 143.849 125.995C131.165 151.844 106.108 170.52 76.3972 174.297C79.9833 174.751 83.6358 174.993 87.3436 175C90.9062 174.994 94.4215 174.788 97.8792 174.391C118.739 171.926 137.352 162.122 151.063 147.633Z",
    fill: "#407093"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M89.481 173.69C94.7751 163.18 108.561 133.335 104.63 114.693L87.5054 108.028L70.3649 114.693C66.3126 133.911 81.0871 165.032 85.9786 174.607C87.155 174.325 88.323 174.019 89.481 173.69Z",
    fill: "#E4F6FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M98.5046 165.357L91.5614 138.042H83.4379L76.5117 165.283L85.0765 174.818C87.2506 174.32 89.3947 173.743 91.5057 173.09L98.5046 165.357Z",
    fill: "#E28086"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M85.2104 174.968C85.9196 174.986 86.6302 174.999 87.3435 175C88.1689 174.999 88.9917 174.984 89.812 174.962L94.2235 170.088C90.7512 171.306 87.1791 172.312 83.5222 173.089L85.2104 174.968Z",
    fill: "#DD636E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M102.12 112.172V96.7686H72.8691V112.172C72.8691 120.249 87.4946 129.072 87.4946 129.072C87.4946 129.072 102.12 120.249 102.12 112.172Z",
    fill: "#FFDDCE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M120.343 61.6322H114.751C111.642 61.6322 109.121 59.1114 109.121 56.0017V52.9204C109.121 48.8698 105.158 46.0059 101.312 47.277C92.3422 50.2418 82.6571 50.2425 73.687 47.2791L73.6764 47.2757C69.8305 46.0052 65.868 48.8691 65.868 52.9194V56.0021C65.868 59.1118 63.3473 61.6325 60.2376 61.6325H54.6465V70.8398C54.6465 73.1924 56.5537 75.1 58.9066 75.1C59.649 75.1 60.253 75.6814 60.2998 76.4224C61.198 90.6644 73.0266 101.939 87.4949 101.939C101.963 101.939 113.792 90.6644 114.69 76.4224C114.737 75.6817 115.341 75.1 116.083 75.1C118.436 75.1 120.343 73.1928 120.343 70.8398V61.6322H120.343Z",
    fill: "#FFDDCE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M114.751 61.6321C111.642 61.6321 109.121 59.1113 109.121 56.0016V52.9203C109.121 48.8697 105.158 46.0058 101.312 47.2769C100.25 47.628 99.1768 47.9342 98.0967 48.2022V78.6125C97.947 88.5069 92.5254 97.1181 84.5188 101.772C85.4967 101.878 86.4886 101.938 87.4945 101.938C101.963 101.938 113.791 90.6636 114.69 76.4216C114.736 75.6809 115.34 75.0992 116.083 75.0992C118.435 75.0992 120.343 73.192 120.343 70.839V61.6317L114.751 61.6321Z",
    fill: "#FFCBBE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M72.8689 108.028L61.3989 117.348L73.4274 132.221C74.8907 133.645 77.1937 133.733 78.7612 132.424L87.8068 124.868L72.8689 108.028Z",
    fill: "#F4FBFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M102.125 108.028L87.8069 124.868L96.3087 132.137C97.8663 133.469 100.18 133.402 101.658 131.982L113.601 117.348L102.125 108.028Z",
    fill: "#F4FBFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M72.8687 108.028L56.0332 116.299C54.7514 116.929 54.2367 118.488 54.8912 119.757L58.1896 126.152C59.0444 127.809 58.7289 129.829 57.4096 131.146C56.7304 131.824 55.9949 132.558 55.3574 133.194C54.2165 134.333 53.8067 136.016 54.3092 137.548C58.2914 149.688 77.4573 168.251 84.7106 174.967C85.1984 174.98 85.6871 174.989 86.1769 174.995C80.917 164.764 62.2778 125.894 72.8687 108.028Z",
    fill: "#365E7D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M117.584 131.146C116.265 129.828 115.95 127.809 116.804 126.152L120.103 119.757C120.757 118.488 120.243 116.929 118.961 116.299L102.125 108.028C112.713 125.889 94.0873 164.742 88.8215 174.986C89.3165 174.978 89.8103 174.965 90.3032 174.949C97.5715 168.217 116.706 149.677 120.685 137.548C121.187 136.016 120.777 134.334 119.637 133.195C118.999 132.558 118.264 131.824 117.584 131.146Z",
    fill: "#365E7D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M87.8066 124.868L78.8994 132.307L83.4378 138.042H91.5613L96.1 131.968L87.8066 124.868Z",
    fill: "#DD636E"
  })), /*#__PURE__*/React.createElement("rect", {
    width: 175,
    height: 43.75,
    transform: "translate(1.75 131.25)",
    fill: "white",
    fillOpacity: 0.5
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_612_21499"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 175,
    height: 175,
    rx: 87.5,
    fill: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_612_21499"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 175,
    height: 175,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgImgProfile);
export default __webpack_public_path__ + "static/media/img-profile.e61b60606106e513133fc164931b104a.svg";
export { ForwardRef as ReactComponent };